
import React, { useState } from 'react';
import { SquarePlus, Calendar, Package, Wrench, ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { AddRentalDialog } from '@/components/rentals/dialogs/AddRentalDialog';
import { AddSaleDialog } from '@/components/sales/dialogs/AddSaleDialog';
import AddRepairDialog from '@/components/workshop/AddRepairDialog';
import { AddOrderDialog } from '@/components/orders/dialogs/AddOrderDialog';
import type { SaleFormData } from '@/types/entities/sale';
import type { RentalFormData } from '@/types/entities/rental';

interface HeaderActionsProps {
  isMobile?: boolean;
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({ isMobile = false }) => {
  const [isAddRentalDialogOpen, setIsAddRentalDialogOpen] = useState(false);
  const [isAddSaleDialogOpen, setIsAddSaleDialogOpen] = useState(false);
  const [isAddRepairDialogOpen, setIsAddRepairDialogOpen] = useState(false);
  const [isAddOrderDialogOpen, setIsAddOrderDialogOpen] = useState(false);

  const handleSaveSale = (data: SaleFormData) => {
    console.log("Sale data saved:", data);
  };

  const handleSaveRental = (data: RentalFormData) => {
    console.log("Rental data saved:", data);
  };

  return (
    <>
      {/* Create Button */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          {isMobile ? (
            <Button className="bg-primary h-12 w-12 p-0 flex items-center justify-center rounded-xl">
              <SquarePlus className="h-5 w-5" />
            </Button>
          ) : (
            <Button className="bg-primary h-10 w-[116px] rounded-xl text-sm flex items-center justify-center">
              <SquarePlus className="mr-2 h-4 w-4" />
              Создать
            </Button>
          )}
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48 bg-white">
          <DropdownMenuItem onClick={() => setIsAddRentalDialogOpen(true)}>
            <Calendar className="mr-2 h-4 w-4" />
            Аренда
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setIsAddOrderDialogOpen(true)}>
            <ShoppingCart className="mr-2 h-4 w-4" />
            Заказ
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setIsAddSaleDialogOpen(true)}>
            <Package className="mr-2 h-4 w-4" />
            Продажа
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setIsAddRepairDialogOpen(true)}>
            <Wrench className="mr-2 h-4 w-4" />
            Ремонт
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Dialogs */}
      <AddRentalDialog 
        isOpen={isAddRentalDialogOpen} 
        onClose={() => setIsAddRentalDialogOpen(false)} 
        onSave={handleSaveRental} 
      />

      <AddSaleDialog 
        isOpen={isAddSaleDialogOpen} 
        onClose={() => setIsAddSaleDialogOpen(false)} 
        onSave={handleSaveSale} 
      />

      <AddRepairDialog 
        isOpen={isAddRepairDialogOpen} 
        onClose={() => setIsAddRepairDialogOpen(false)} 
      />

      <AddOrderDialog
        isOpen={isAddOrderDialogOpen}
        onClose={() => setIsAddOrderDialogOpen(false)}
      />
    </>
  );
};
